module.exports = __webpack_public_path__ + "static/img/forget-by-phone.60804a71.png";